import { Component, Renderer2, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
	L10N_CONFIG,
	L10N_LOCALE, L10nConfig,
	L10nLocale,
	L10nTranslatePipe, L10nTranslationService,
} from 'angular-l10n';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';

import { LoggerService } from '../../shared/logger.service';
import { SessionService } from '../../shared/session.service';
import {DOCUMENT} from "@angular/common";
import {AngularMaterial2Module} from "../../app.module.material";

const PATH_FILE = 'app/protected/shop/shop.component.ts';
const OBJ_LNG_NAME = 'shop';

@Component({
    selector: 'oase-shop',
    templateUrl: './shop.component.html',
    styleUrls: ['./shop.component.css'],
    standalone:true,	imports: [ AngularMaterial2Module, L10nTranslatePipe ]

})
export class ShopComponent implements OnInit {

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
	@Inject(L10N_LOCALE) public locale: L10nLocale,
	@Inject(L10N_CONFIG) private config: L10nConfig,
	public translation: L10nTranslationService,
	public sessService: SessionService,
    public title: Title,
    private _logger: LoggerService) {
    // super(locale, translation);
    // Set document title.
    this.title.setTitle(this.getTitle());
    // this.translation.translationChanged.subscribe(() => {
    //   this.title.setTitle(this.getTitle());
    // });
  }

  ngOnInit() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'assets/js/shop.js';
    s.text = ``;
    this.renderer2.appendChild(this._document.body, s);
 }

  getTitle() {
    return this.translation.translate('Shop.title') + ' - ' + this.translation.translate('project.title');
  }
}
